import * as React from 'react';
import Model from './owner-model';
import BasePicklist from '../base/base-picklist.component';
import AppService from '../../services/app.service';

interface IProps { 
  currentId?: number;  
  onLoad?: (data: any) => void;
}

interface IState {
}

export default class OwnerPicklist extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render(): React.ReactNode {
    return (
      <BasePicklist model={Model} endPointFilter={AppService.isAppFullVersion()? '' : Model.endPointFilter()} currentId={this.props.currentId} onLoad={this.props.onLoad} disableBackButton/>
    );
  }
}
